import { useEffect, useState } from 'react';

import { useFeatureGate } from '@ctct/awesome-feature-flags';

import MyAccountApi from '../api/MyAccountApi';

const STRIPE_SCHEDULED_DOWNGRADE_STATSIG_FEATURE_GATE = 'enable_stripe_scheduled_downgrade';

const useStripeScheduledDowngrade = ({ isOpen, isStripeAccount }) => {
  const [hasScheduledDowngrade, setHasScheduledDowngrade] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { data: isStripeScheduledDowngradeEnabled } = useFeatureGate({
    name: STRIPE_SCHEDULED_DOWNGRADE_STATSIG_FEATURE_GATE,
    defaultValue: false,
  });

  useEffect(() => {
    if (!isOpen || !isStripeAccount || !isStripeScheduledDowngradeEnabled) {
      setHasScheduledDowngrade(false);

      return;
    }

    setIsLoading(true);

    MyAccountApi.getStripeScheduledDowngrade()
      .then((result) => {
        setHasScheduledDowngrade(Boolean(result));
      })
      .catch(() => {
        setHasScheduledDowngrade(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [isOpen, isStripeAccount, isStripeScheduledDowngradeEnabled]);

  const cancelScheduledDowngrade = async () => {
    setIsLoading(true);

    try {
      await MyAccountApi.cancelStripeScheduledDowngrade();
      setHasScheduledDowngrade(false);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    hasScheduledDowngrade,
    isLoading,
    cancelScheduledDowngrade,
  };
};

export default useStripeScheduledDowngrade;
